export default "__VITE_ASSET__SKNJCv03__"